<template>
    <div>
        <!-- Bank name -->
        <div class="row tw-mb-4">
            <div class="col-md-6">
                <label class="required form-col-label control-label">{{
                    $t("bankProfile.bankName")
                }}</label>
                <Input
                    v-model="model.bank_name"
                    :placeholder="$t('bankProfile.bankName')"
                    :class="{ 'is-invalid': validate.has('bank_name') }"
                />
                <div class="invalid-feedback" v-if="validate.has('bank_name')">
                    {{ validate.first("bank_name") }}
                </div>
            </div>
        </div>

        <!-- Accounts -->
        <div v-if="showAccounts">
            <div class="tw-flex tw-items-center tw-justify-between tw-mb-2">
                <h6 class="tw-font-semibold tw-mb-0">{{ $t("bankProfile.accounts") }}</h6>
                <Button v-if="!readonly" size="small" type="primary" ghost @click="addRow">
                    <i class="fas fa-plus tw-mr-1"></i>{{ $t("addNew") }}
                </Button>
            </div>

            <!-- Readonly: plain table -->
            <Table
                v-if="readonly"
                :columns="readonlyColumns"
                :data="model.accounts || []"
                size="small"
                stripe
                :no-data-text="$t('bankProfile.noAccounts')"
            ></Table>

            <!-- Editable: inline inputs -->
            <Table
                v-else
                :columns="editableColumns"
                :data="model.accounts"
                size="small"
                stripe
                :no-data-text="$t('bankProfile.noAccounts')"
            >
                <template slot-scope="{ index }" slot="account_no">
                    <Input
                        v-model="model.accounts[index].account_no"
                        size="small"
                        :placeholder="$t('bankProfile.accountNo')"
                        :class="{ 'is-invalid': validate.has(`accounts.${index}.account_no`) }"
                    />
                    <div
                        class="invalid-feedback tw-text-xs"
                        v-if="validate.has(`accounts.${index}.account_no`)"
                    >
                        {{ validate.first(`accounts.${index}.account_no`) }}
                    </div>
                </template>

                <template slot-scope="{ index }" slot="account_name">
                    <Input
                        v-model="model.accounts[index].account_name"
                        size="small"
                        :placeholder="$t('bankProfile.accountName')"
                        :class="{ 'is-invalid': validate.has(`accounts.${index}.account_name`) }"
                    />
                    <div
                        class="invalid-feedback tw-text-xs"
                        v-if="validate.has(`accounts.${index}.account_name`)"
                    >
                        {{ validate.first(`accounts.${index}.account_name`) }}
                    </div>
                </template>

                <template slot-scope="{ index }" slot="action">
                    <a
                        href="#"
                        class="text-danger"
                        @click.prevent="removeRow(index)"
                        v-tooltip="$t('delete')"
                    >
                        <Icon type="ios-trash" size="18" />
                    </a>
                </template>
            </Table>
        </div>
    </div>
</template>

<script>
export default {
    name: "BankProfileFormInput",
    props: {
        value: { type: Object, required: true },
        validate: { type: Object, required: true },
        showAccounts: { type: Boolean, default: true },
        readonly: { type: Boolean, default: false }
    },
    computed: {
        model() {
            return this.value;
        },
        readonlyColumns() {
            return [
                {
                    title: this.$t("bankProfile.accountNo"),
                    key: "account_no",
                    minWidth: 180
                },
                {
                    title: this.$t("bankProfile.accountName"),
                    key: "account_name",
                    minWidth: 220
                }
            ];
        },
        editableColumns() {
            return [
                {
                    title: this.$t("bankProfile.accountNo"),
                    slot: "account_no",
                    minWidth: 180
                },
                {
                    title: this.$t("bankProfile.accountName"),
                    slot: "account_name",
                    minWidth: 220
                },
                {
                    title: "",
                    slot: "action",
                    align: "center",
                    width: 60
                }
            ];
        }
    },
    methods: {
        addRow() {
            this.model.accounts.push({ account_no: "", account_name: "" });
        },
        removeRow(index) {
            this.model.accounts.splice(index, 1);
        }
    }
};
</script>
